<template>
  <div style="width: 100%; display: flex">
    <div class="header-n" v-bind:class="inverse ? 'inverse ' + customClass : customClass">
      <div class="header-desktop">
        <img
          src="@/assets/logo-white.png"
          class="logo"
          alt=""
          @click="toHome"
          v-if="!inverse"
        />
        <img
          src="@/assets/logo-blue.svg"
          class="logo"
          alt=""
          @click="toHome"
          v-else
        />
        <div class="hd-nav-container">
          <ul class="hd-nav-list">
            <li v-if="isDashboard">
              <a :href="'/#/'" class="fw-bold" aria-label="Dashboard">Dashboard</a>
            </li>
            <li>
              <a
                aria-label="About Us"
                :href="`${mv_url}/about-us/`"
                v-bind:class="activeMenu === 'about-us' ? 'fw-bold' : ''"
              >
                About Us
              </a>
            </li>
            <li>
              <a
                aria-label="For Musicians"
                @click="toMusicians"
                v-bind:class="activeMenu === 'musicians' ? 'fw-bold' : ''"
              >
                For Musicians
              </a>
            </li>
            <li>
              <a
                :href="`/#/donation-page`"
                aria-label="Missions Project"
              >Missions Project
              </a>
            </li>
            <li>
              <a :href="playerUrl" aria-label="Web Player">Web Player</a>
            </li>
            <li>
              <a :href="'/#/premium'" aria-label="Premium">Premium</a>
            </li>
          </ul>
          <div class="hd-nav-action" v-if="!isDashboard">
            <a
              class="btn-n primary"
              :href="`/#/register`"
              aria-label="Sign Up"
            >
              Sign Up
            </a>
            <a
              class="btn-n"
              v-bind:class="inverse ? 'outline-primary' : 'outline'"
              :href="`/#/login`"
              aria-label="Log In"
            >
              Log In
            </a>
          </div>
          <b-dropdown variant="link" toggle-class="text-decoration-none d-flex" menu-class="bg-menu-dropdown" no-caret v-if="isDashboard && userProfile">
            <template #button-content class="">
              <img :src="!!getUser.data.avatar?getUser.data.avatar:defaultLogo" width="36" height="36" class="my-auto rounded-circle mr-2">
              <span class="text-white my-auto mr-2 d-none d-md-block">{{getUser.data.name}}</span>
              <font-awesome-icon :icon="['fas', 'chevron-down']" class="text-white my-auto" />
            </template>
            <b-dropdown-item to="/home" class="d-block d-sm-none text-white" :link-class="'text-white'">Dashboard</b-dropdown-item>
            <b-dropdown-item :href="`${mv_url}/about-us/`" class="d-block d-sm-none text-white" :link-class="'text-white'">About us</b-dropdown-item>
            <b-dropdown-item :href="`${mv_url}/musicians/`" class="d-block d-sm-none text-white" :link-class="'text-white'">Musicians</b-dropdown-item>
            <b-dropdown-item :href="`${mv_url}/blog/`" class="d-block d-sm-none text-white" :link-class="'text-white'">Blog</b-dropdown-item>
            <b-dropdown-item to="donation-lists" class="d-block d-sm-none text-white" :link-class="'text-white'">Mission Projects</b-dropdown-item>
            <b-dropdown-item v-if="isMonthlySubscriber" @click="manageMembership"  class="text-white" :link-class="'text-white'">Manage Membership</b-dropdown-item>
            <b-dropdown-item @click="logout" class="text-white" :link-class="'text-white'">Logout</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <div class="header-mobile">
        <img
          src="@/assets/logo-white.png"
          class="logo"
          alt="MusicVerse logo"
          @click="toHome"
        />
        <div class="hm-hamburger" @click="toggleMenuMobile">
          <img src="@/assets/hamburger.svg" alt="hamburger icon" />
        </div>
      </div>
    </div>
    <div class="header-menu-mobile" v-if="openMenuMobile">
      <div class="hmm-container">
        <div class="hmm-header">
          <img src="@/assets/logo-blue.svg" alt="logo" />
          <a
            href="javascript:void(0)"
            aria-label="close"
            class="close"
            @click="toggleMenuMobile"
          >
            &times;
          </a>
        </div>
        <div class="hmm-nav">
          <div class="hmm-nav-item" v-if="isDashboard" @click="toDashboard">Dashboard</div>
          <div class="hmm-nav-item" @click="toAbout">About Us</div>
          <div class="hmm-nav-item" @click="toMusicians">For Musicians</div>
          <div class="hmm-nav-item" @click="toMissions">Missions</div>
          <div class="hmm-nav-item" @click="toPlayer">Web Player</div>
          <div class="hmm-nav-item" @click="toPremium">Premium</div>
          <div class="hmm-nav-item" v-if="isMonthlySubscriber && isDashboard" @click="manageMembership">Manage Membership</div>
          <div class="hmm-nav-item" @click="logout" v-if="isDashboard" >Logout</div>
          <div class="hmm-nav-item action" v-if="!isDashboard">
            <a
              class="btn-n primary"
              :href="`${accountUrl}/#/register`"
              aria-label="Sign Up"
            >
              Sign Up
            </a>
            <a
              class="btn-n outline-primary"
              :href="`${accountUrl}/#/login`"
              aria-label="Log In"
            >
              Log In
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import defaultLogo from '@/assets/user-icon.png';
export default {
  name: 'HeaderLandingNew',
  props: {
    activeMenu: {
      type: String,
    },
    inverse: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    customClass: {
      type: String,
      default: () => {
        return '';
      }
    },
    isDashboard: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
  },
  data: () => ({
    defaultLogo,
    playerUrl: process.env.PLAYER_URL,
    accountUrl: process.env.VUE_APP_ACCOUNT_URL,
    dashboardUrl: process.env.DASHBOARD_URL,
    mv_url: process.env.MUSICVERSE_URL,
    openMenuMobile: false,
    userProfile: null,
  }),
  watch: {
    getUser: {
      immediate: true,
      deep: true,
      async handler(val) {
        this.userProfile = val.data;
      },
    },
  },
  computed: {
    ...mapGetters('NotificationModule', ['isLoading', 'getStatus', 'getMessage', 'getErrorCode', 'getToggleManageMembership']),
    ...mapGetters('AuthModule', ['accessToken', 'getUser']),
    isSubsriber() {
      if (this.userProfile) {
        if (this.userProfile.type === 1 && this.userProfile.subscription !== null) {
          return true;
        }
        return false;
      }
      return false;
    },
    isMonthlySubscriber() {
      if (this.isSubsriber) {
        // eslint-disable-next-line max-len
        const condition1 = this.userProfile.subscription.recurring === 1;
        const condition2 = !this.userProfile.subscription.canceled;
        const condition3 = this.userProfile.subscription.canceled && !this.userProfile.subscription.change_amount;
        if (condition1 && (condition2 || condition3)) {
          return true;
        }
      }
      return false;
    },
    isOneTimeSubscriber() {
      if (this.isSubsriber) {
        // eslint-disable-next-line max-len
        if ((this.userProfile.subscription.canceled || (!this.userProfile.subscription.canceled && this.userProfile.subscription.recurring === 0))) {
          return true;
        }
      }
      return false;
    },
    isChangeAmount() {
      if (this.isMonthlySubscriber) {
        if (this.userProfile.subscription.canceled && !this.userProfile.subscription.change_amount) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    ...mapActions('AuthModule', ['removeAuthentication', 'requestDetailUser']),
    ...mapActions('NotificationModule', ['setManageMembership']),
    async logout() {
      // eslint-disable-next-line max-len
      const result = await this.removeAuthentication({ accessToken: this.accessToken, tokenType: this.tokenType });
      if (result) {
        this.$router.go();
        window.location.reload();
      }
    },
    toHome() {
      this.$router.push("/login");
    },
    manageMembership() {
      this.setManageMembership(true);
    },
    toAbout() {
      window.location.href = this.mv_url+'/about-us';
    },
    toMusicians() {
      this.openMenuMobile = false;
      window.location.href = this.mv_url+'/musicians';
    },
    toPlayer() {
      this.openMenuMobile = false;
      window.location.href = this.playerUrl;
    },
    toPremium() {
      this.openMenuMobile = false;
      this.$router.push("/premium");
    },
    toMissions() {
      this.openMenuMobile = false;
      this.$router.push("/donation-page");
    },
    toDashboard() {
      this.openMenuMobile = false;
      this.$router.push("/");
    },
    toggleMenuMobile() {
      this.openMenuMobile = !this.openMenuMobile;
    },
  }
};
</script>

<style>
  @import '../assets/stylesheets/header.css';
</style>



// WEBPACK FOOTER //
// src/components/HeaderLandingNew.vue